import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {NavigationService} from "../service/navigation.service";
import {ContractsService} from "../service/contracts.service";
import {BankService} from "../service/bank.service";
import {Vehicle} from "../domain/vehicle";
import {Contract} from "../domain/contract";
import {Bank} from "../domain/bank";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload/ng2-file-upload";
import {FILE_MAX_SIZE} from "../validators/validators";

@Component({
    selector: 'contracts-panel',
    template: require('./contracts.panel.component.html'),
    styles: [require('./contracts.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*DATEPICKER_DIRECTIVES,*/
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ContractsPanelComponent implements OnInit, AfterViewInit {

    private data: Contract[];

    private filter: Vehicle;

    private banks: Bank[];

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    public contractSelected: Contract;

    @ViewChild('deleteModal') deleteModal: ModalDirective;
    public vehiclesSelected: Vehicle[];

    public bankTodos: Bank;

    private canEditVehicle: boolean;
    private canDeleteVehicle: boolean;
    private canViewVehicle: boolean;
    private canEditContract: boolean;
    private canDeleteContract: boolean;
    private canViewContract: boolean;

    public showFilters: boolean;

    public oneClickBulkLoad: boolean;

    @ViewChild('bulkLoadContract') bulkLoad: ElementRef;
    @ViewChild('bulkLoadContractModal') bulkLoadModal: ModalDirective;
    public errorsBulkLoad: string[];

    public uploaderBulkLoad: FileUploader;
    public hasBulkLoadDropZoneOver: boolean;

    constructor(private router: Router,
                private contractsService: ContractsService,
                private bankService: BankService,
                private navigationService: NavigationService,
                private loginService: LoginService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los bancos.')
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {
        this.data = [];

        this.filter = new Vehicle();

        this.form = new FormGroup({
            patent: new FormControl(),
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),
            itemsPerPage: new FormControl()
        });

        this.banks = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();

        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

        this.canEditVehicle = false;
        this.canDeleteVehicle = false;
        this.canViewVehicle = false;
        this.canEditContract = false;
        this.canDeleteContract = false;
        this.canViewContract = false;

        this.showFilters = false;

        this.errorsBulkLoad = [];

        this.createUploaderBulkLoad();

        this.oneClickBulkLoad = false;
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit ||
            (this.filter.contract.bank && this.filter.contract.bank.id != ''));
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
            if (!this.filterEmpty()) {
                this.loading = true;
                this.contractsService.findContracts(this.filter, page, this.itemsPerPage)
                    .subscribe(
                        (data) => {
                            this.refreshData(data);
                            this.page = page;
                        },
                        () => {
                            this.bindError('Ocurrió un error al cargar los contratos.');
                        });
            }
        } else {
            this.bindError('Cantidad de ítems no válida.');
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content.map((item) => new Contract(item));
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public getVehicles(item: Contract): void {
        this.loading = true;
        this.contractSelected = item;
        this.vehiclesSelected = null;
        this.contractsService.getVehicles(this.contractSelected.id)
            .subscribe(
                (data) => {
                    if (data.length > 0) {
                        this.vehiclesSelected = data;
                    }
                    this.loading = false;
                    this.deleteModal.show();
                },
                () => {
                    this.bindError('Ocurrió un error al cargar los vehículos.');
                });
    }

    public removeItem(deleteModal: any): void {
        this.error = null;
        this.contractsService.delete(this.contractSelected.id)
            .subscribe(
                () => {
                    deleteModal.hide();
                    this.removeItemFromView(this.contractSelected);
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar el contrato.');
                });
    }

    public removeItemFromView(item: Contract): void {
        let index = this.data.indexOf(item);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.contractSelected = null;
        this.vehiclesSelected = [];
    }

    public editItem(item: Contract): void {
        this.navigationService.setBackParameters({tabSelected: 'contracts'});
        this.router.navigate(['app/home/editContract', item.id]);
    }

    public create(): void {
        this.navigationService.setBackParameters({tabSelected: 'contracts'});
        this.router.navigate(['app/home/createContract']);
    }

    public downloadFilterContracts(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';

            /*
             * Se exportan todos los contratos que cumplan con el filtro.
             * Sólo los contratos de la página actual se descargan.
             */
            let url = window.location.origin +
                ContractsService.getURLFilterContracts(this.filter, this.page, this.itemsPerPage);
            window.location.href = url;

            this.loading = false;

            /*this.contractsService.downloadFilterContracts(this.filter, this.page, this.itemsPerPage).subscribe(
             data => {
             this.loading = false;
             if (data.url == null) {
             if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) ||
             navigator.userAgent.match(/rv 11/))) {
             /!*alert("Please dont use IE.");*!/
             window.location.href = this.contractsService
             .downloadFilterContractsForIE(this.filter, this.page, this.itemsPerPage);
             } else {
             this.bindError('Ocurrió un error al descargar los contratos filtrados.');
             }
             } else {
             window.location.href = data.url;
             }
             },
             () => {
             this.bindError('Ocurrió un error al descargar los contratos filtrados.');
             });*/
        }
    }

    public close(saved: Contract): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();

        this.canEditVehicle = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'VEHICLES');
        this.canDeleteVehicle = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'VEHICLES');
        this.canViewVehicle = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'VEHICLES');
        this.canEditContract = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'CONTRACTS');
        this.canDeleteContract = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'CONTRACTS');
        this.canViewContract = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'CONTRACTS');

        if (userLogged.rol.client) {
            if (userLogged.cuit) {
                this.filter.contract.cuit = userLogged.username;
            } else {
                this.filter.patent = userLogged.username;
            }
            this.filter.contract.bank.id = userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
    }

    public createUploaderBulkLoad(): void {
        this.uploaderBulkLoad = new FileUploader({
            url: 'contract/bulkLoad',
            maxFileSize: FILE_MAX_SIZE,
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']*/
        });
        this.hasBulkLoadDropZoneOver = false;

        this.uploaderBulkLoad.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        ContractsService.getURLContractBulkload(message[1]);
                }
            } else if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de contratos no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        ContractsService.getURLContractBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de contratos cancelada.");
                }
            }
            this.showBulkLoadModal();
            this.oneClickBulkLoad = false;
        };
    }

    public ngAfterViewInit() {
        /*Limpieza de inputs al agregar a la cola el archivo*/
        this.uploaderBulkLoad.onAfterAddingFile = (
            item => {
                this.bulkLoad.nativeElement.value = '';
                this.reportMessage = null;
            });
    }

    public showBulkLoadModal(): void {
        this.bulkLoadModal.show();
        this.disableLoading();
    }

    public hideBulkLoadModal(): void {
        this.bulkLoadModal.hide();
        this.errorsBulkLoad = [];
    }

    public disableLoading(): void {
        this.loading = false;
        this.oneClickBulkLoad = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    public enableOneClickBulkload(): void {
        this.oneClickBulkLoad = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/contracts/contracts.panel.component.ts
 **/